import React, { createContext, useContext } from 'react'

export interface ModuleConfig {
  id: number
  name: string
  coachFlowId: number
  roleplayFlowId: number
  reviewPromptPayloadId: number
  timerDuration: number
  defaultRemainingTime: number
  reviewPageSize: number
}

export const DEFAULT_MODULE_CONFIG: ModuleConfig = {
  id: 0,
  name: '',
  coachFlowId: 10,
  roleplayFlowId: 11,
  reviewPromptPayloadId: 60,
  timerDuration: 180,
  defaultRemainingTime: 300,
  reviewPageSize: 10,
}

const ModuleConfigContext = createContext<ModuleConfig>(DEFAULT_MODULE_CONFIG)

export const ModuleConfigProvider: React.FC<{
  value: ModuleConfig
  children: React.ReactNode
}> = ({ value, children }) => {
  return <ModuleConfigContext.Provider value={value}>{children}</ModuleConfigContext.Provider>
}

export const useModuleConfig = (): ModuleConfig => {
  return useContext(ModuleConfigContext)
}
